// extracted by mini-css-extract-plugin
module.exports = {"version":"Version-version-02672e4fec76ad7f22ee5a96dd4a8ffe"};